/**
 * @desc 启用/停用模板
 */
import { EnableTemplateParam } from '@eastcoal/api/contract/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type EnableTemplateParameter = EnableTemplateParam

const method = 'PUT'
const url = '/contract/template/enable'

export const enableTemplateApi = (
  data?: EnableTemplateParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

enableTemplateApi.method = method
enableTemplateApi.url = url
